import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const CART_KEY = "maison_cart";
const WISH_KEY = "moda_wishlist";

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch { return []; }
  });
  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(CART_KEY, JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem(WISH_KEY, JSON.stringify(wishlist)); }, [wishlist]);

  const addToCart = (product, size, color, quantity = 1) => {
    const image = product.images?.[0] || null;
    setCart((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id && i.size === size && i.color === color);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [...prev, { product_id: product.id, name: product.name, price: product.price, image, size, color, quantity }];
    });
    toast.success("Added to bag", { description: product.name });
  };

  const updateQty = (i, q) => setCart((prev) => prev.map((it, idx) => (idx === i ? { ...it, quantity: Math.max(1, q) } : it)));
  const removeItem = (i) => setCart((prev) => prev.filter((_, idx) => idx !== i));
  const clearCart = () => setCart([]);
  const cartCount = cart.reduce((s, i) => s + i.quantity, 0);
  const cartTotal = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  const toggleWishlist = (productId) => {
    const added = !wishlist.includes(productId);
    setWishlist((prev) => (added ? [...prev, productId] : prev.filter((x) => x !== productId)));
    toast[added ? "success" : "message"](added ? "Saved to favorites" : "Removed from favorites");
    return added;
  };
  const inWishlist = (id) => wishlist.includes(id);

  return (
    <StoreContext.Provider value={{ cart, cartCount, cartTotal, addToCart, updateQty, removeItem, clearCart, wishlist, toggleWishlist, inWishlist }}>
      {children}
    </StoreContext.Provider>
  );
}
